import { motion } from "framer-motion";
import { 
  Search, 
  Sparkles, 
  FileCheck, 
  Wand2, 
  Globe2, 
  Zap,
  Shield,
  Target
} from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export function Features() {
  const { t } = useLanguage();

  const features = [
    { icon: Search, title: t.features.aiJobSearch, description: t.features.aiJobSearchDesc, color: "primary" },
    { icon: Target, title: t.features.smartMatching, description: t.features.smartMatchingDesc, color: "accent" },
    { icon: Sparkles, title: t.features.aiDiagnostics, description: t.features.aiDiagnosticsDesc, color: "primary" },
    { icon: Wand2, title: t.features.aiCVFix, description: t.features.aiCVFixDesc, color: "accent" },
    { icon: FileCheck, title: t.features.cvGenerator, description: t.features.cvGeneratorDesc, color: "primary" },
    { icon: Globe2, title: t.features.euFocus, description: t.features.euFocusDesc, color: "accent" },
    { icon: Zap, title: t.features.realtime, description: t.features.realtimeDesc, color: "primary" },
    { icon: Shield, title: t.features.privacy, description: t.features.privacyDesc, color: "accent" },
  ];

  return (
    <section className="py-24 relative">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
            {t.features.title}{" "}
            <span className="text-gradient">{t.features.titleHighlight}</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            {t.features.subtitle}
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative"
              >
                <div className="h-full p-6 rounded-2xl bg-gradient-card border border-border hover:border-white/20 transition-all duration-300">
                  <div className={`
                    w-12 h-12 rounded-xl flex items-center justify-center mb-4
                    ${feature.color === 'accent' 
                      ? 'bg-accent/10 text-accent' 
                      : 'bg-primary/10 text-primary'
                    }
                    group-hover:scale-110 transition-transform duration-300
                  `}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-display font-semibold text-lg mb-2 text-foreground">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {feature.description}
                  </p>
                  <div className={`
                    absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 blur-xl
                    ${feature.color === 'accent' 
                      ? 'bg-accent/10' 
                      : 'bg-primary/10'
                    }
                  `} />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
